import { Big } from 'big.js';

export function compareOrder(
  a: { order?: Big; Order: string | number; Id?: string; id?: string },
  b: { order?: Big; Order: string | number; Id?: string; id?: string },
): number {
  let aBig: Big;
  if (a.order !== undefined) {
    aBig = a.order;
  } else if (a.Order !== undefined) {
    aBig = Big(a.Order);
  } else {
    aBig = Big(Number.MAX_SAFE_INTEGER);
  }

  let bBig: Big;
  if (b.order !== undefined) {
    bBig = b.order;
  } else if (b.Order !== undefined) {
    bBig = Big(b.Order);
  } else {
    bBig = Big(Number.MAX_SAFE_INTEGER);
  }

  const cmp = aBig.cmp(bBig);

  if (cmp === 0) {
    const aId = a.Id || a.id || '';
    const bId = b.Id || b.id || '';
    return aId.localeCompare(bId);
  }

  return cmp;
}

export function compareZIndex(
  a: { zIndex?: Big; ZIndex: string | number; Id?: string; id?: string },
  b: { zIndex?: Big; ZIndex: string | number; Id?: string; id?: string },
) {
  return compareOrder(
    { id: a.id, Id: a.Id, order: a.zIndex, Order: a.ZIndex },
    { id: b.id, Id: b.Id, order: b.zIndex, Order: b.ZIndex },
  );
}

type ItemWithZIndex = { ZIndex: string };

export const regenerateSlideItemsZIndexes = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  itemsRecord: Record<string, any[]>,
) => {
  const newItemsRecord: typeof itemsRecord = {};

  Object.keys(itemsRecord).forEach(type => {
    newItemsRecord[type] = [];
  });

  const grouped: {
    itemType: string;
    itemData: ItemWithZIndex;
    originalIndex: number;
  }[] = [];

  Object.entries(itemsRecord).forEach(([itemType, itemArray]) => {
    // we need this function to return the elements in the original order so
    // when the view renders them it renders in the old order
    // all of this is just to keep compatibility with the french scripts
    let i = 0;

    itemArray.forEach(itemData => {
      grouped.push({
        itemType,
        itemData,
        originalIndex: i,
      });
      i += 1;
    });
  });

  grouped.sort((a, b) => compareZIndex(a.itemData, b.itemData));

  grouped.forEach(({ itemType, itemData, originalIndex }, index) => {
    newItemsRecord[itemType].push({
      ...itemData,
      originalIndex,
      ZIndex: String(index + 1),
    });
  });

  Object.values(newItemsRecord).forEach(array => {
    array.sort((a, b) => a.originalIndex - b.originalIndex);
    array.forEach(item => {
      // eslint-disable-next-line no-param-reassign
      delete item.originalIndex;
    });
  });

  return newItemsRecord;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const changeZIndexToIntegers = ({ slides, ...restGenially }: any) => ({
  ...restGenially,
  slides: slides.map(
    ({
      activities = [],
      areas = [],
      arrows = [],
      audios = [],
      videos = [],
      richContents = [],
      pins = [],
      images = [],
      svgs = [],
      texts = [],
      groups = [],
      charts = [],
      ...restSlide
    }) => ({
      ...restSlide,
      ...regenerateSlideItemsZIndexes({
        activities,
        areas,
        arrows,
        audios,
        videos,
        richContents,
        pins,
        images,
        svgs,
        texts,
        groups,
        charts,
      }),
    }),
  ),
});
